<template>
  <el-popover
    v-model="visible"
    placement="bottom"
    width="240"
    trigger="click"
    popper-class="group-field-popover"
  >
    <div>
      <div class="gfp-title">
        {{ $l('title_choose_group_fields') || '选择分组字段' }}
      </div>
      <div class="gfp-list">
        <el-checkbox-group
          v-model="localGroupFields"
          @change="changeGroupFields"
        >
          <label
            v-for="field in groupableFields"
            :key="field.key"
            class="gfp-item"
          >
            <el-checkbox :label="field.key">{{ field.label }}</el-checkbox>
          </label>
        </el-checkbox-group>
      </div>
      <div class="gfp-actions">
        <button class="gfp-clear" @click="clearGroupFields">
          {{ $l('btn_clear_group') || '清空分组' }}
        </button>
      </div>
    </div>

    <button
      slot="reference"
      class="pool-action-btn"
      :class="{ active: localGroupFields.length > 0 }"
    >
      <i class="el-icon-s-grid" />
      {{ $l('btn_group') || '分组' }}
    </button>
  </el-popover>
</template>

<script>
export default {
  props: {
    groupFields: { type: Array, default: () => [] },
    groupableFields: { type: Array, default: () => [] },
  },
  data() {
    return {
      visible: false,
      localGroupFields: [...this.groupFields],
    }
  },
  watch: {
    groupFields(val) {
      this.localGroupFields = [...(val || [])]
    },
  },
  methods: {
    changeGroupFields(val = []) {
      this.$emit('change-group-fields', [...val])
    },
    clearGroupFields() {
      this.localGroupFields = []
      this.changeGroupFields([])
    },
  },
}
</script>

<style scoped>
.pool-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
  white-space: nowrap;
  i {
    font-size: 13px;
  }
}

.pool-action-btn:hover {
  background: #e2e8f0;
  color: #334155;
}

.pool-action-btn.active {
  background: #ecf5ff;
  border-color: #409eff;
  color: #409eff;
}

.gfp-title {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f1f5f9;
}

.gfp-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 280px;
  overflow-y: auto;
}

.gfp-item {
  display: flex;
  align-items: center;
  padding: 4px 2px;
  font-size: 12px;
  color: #334155;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.15s;
}

.gfp-item:hover {
  background: #f8fafc;
}

.gfp-actions {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #f1f5f9;
}

.gfp-clear {
  background: none;
  border: none;
  color: #ef4444;
  font-size: 11px;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
  font-family: inherit;
}

.gfp-clear:hover {
  background: #fef2f2;
}
</style>
